const dictionaryEN = {
  originalWriting: 'English',
  general: {
    user: 'User',
    email: 'E-mail',
    password: 'Password',
    close: 'Close',
    save: 'Save',
    done: 'Done',
    accept: 'Accept',
    cancel: 'Cancel',
    decline: 'Decline',
    cut: 'Cut',
    browse: 'Browser',
    chooseFileLabel: 'Choose file...',
    selectedCountLabel: 'files selected',
    from: 'from',
    perDay: 'per day',
    select: 'Select',
    owner: 'Owner',
    details: 'Details',
    sizeList:[
      'None',
      'Small',
      'Medium',
      'Large'
    ],
    options: 'Options',
    status: 'Status',
    pay: 'Pay',
    edit: 'Edit',
    from: 'From',
    to: 'To',
    date: 'Date',
    place: 'Place',
    empty: 'Empty',
    full: 'Full',
    go: 'Go',
    uploadImagesLabel: 'Upload images (Max %%)',
    uploadListLimitMessage: 'You must select %% images to upload',
    back: 'Back',
    car: 'Car',
    decide: 'Decide',
    clear: 'Clear',
    document: 'Document',
  },
  user: {
    login: {
      title: 'Login',
      userMailLabel: 'User or Email',
      userMailPlaceHolder: 'User name or email',
      userPasswordLabel: 'Password',
      userPasswordPlaceholder: 'Password',
      loginButtonLabel: 'Log In',
      newUserLabel: 'New Account',
      successfulLabel: 'You are currently logged'
    },
    reset: {
      titleDialog: 'Forgot Password Recovery',
      requestNewPassword: 'Password Recovery',
      generateNewPassword: 'Generate New Password',
      getKey: 'I get a code',
      userResetTokenLabel: 'Reset Token Key',
      userResetTokenPlaceholder: 'Reset token key',
      requestNewPasswordLabel: 'Request New',
      changePasswordLabel: 'Change Password',
      requestPasswordMessage: "If entered email was registered in our database, then a code has been sent to it's inbox",
      executePasswordMessage: 'User password has been changed, you can login now',
    },
    newAccount: {
      titleDialog: 'Register new user',
      titleForm: 'New user',
      userNameLabel: 'User',
      userNamePlaceHolder: 'User name (min 8 characters)',
      userEmailLabel: 'E-mail',
      userEmailPlaceholder: 'E-mail',
      userPasswordLabel: 'Password',
      userPasswordAllowedCharsMessage: 'Allowed characters: Uppercase,lowercase, numbers and @$!%*?&',
      userPasswordPlaceholder: 'Password (min 8 characters)',
      userPasswordConfirmLabel: 'Password Confirm',
      userPasswordConfirmPlaceHolder: 'Password confirm',
      userAgreementCheckbox: 'I fully accept agreement',
      userAgreementViewDoc: 'View agreement',
      userMissingFieldsMessage: 'Some fields are missing, please fill required fields.',
      userMinLengthMessage: 'User name must be at least 8 characters.',
      userEmailValidMessage: 'Please, enter a valid email.',
      userPasswordValidationsMessage: 'Password is not strong enough. Must have at least 8 characters <br/> Must have at least 1 lower case letter.<br/>Must have at least 1 upper case letter<br/>Must have one number.<br/>It must have at least one of these characters: @$!%*?&',
      userPasswordMismatchMessage: 'Password mismatch.',
      userAcceptAgreementMessage: 'You must accept have read and accept our agreement terms.',
      userSuccesfullyCreatedMessage: 'User has been created. Please, open your email account and enable it.',
    },
    edit: {
      title: 'User Account Edition',
      tabs: [
        'User Account',
        'Personal',
        'Location',
        'Car Data',
      ],
      account: {
        avatarSelection: 'Avatar edition/selection',
        avatarUploadImage: 'Upload image',
        avatarSave: 'Save',
        uploadAvatarOkMessage: 'Avatar image successfully updated',
        instructionsLabel: 'Instructions',
        instructionsStepOne: 'Select a file to upload',
        instructionsStepTwo: 'Ajust the image in the section to your choice: move, center, zoom, etc',
        instructionsStepThree: 'Press the [Cut] button the selected section, that will be your avatar image',
        instructionsStepFour: 'Press [Save] to add or update your current avatar image',
      },
      personal: {
        title: 'Personal Data',
        contactFullName: 'Full name',
        contactFirstName: 'First Name',
        contactLastName: 'Last Name',
        contactGenderLabel: 'Gender',
        contactGenderMale: 'Male',
        contactGenderFemale: 'Female',
        contactGenderX: 'X',
        contactBirthDateLabel: 'Birth Date',
        contactNotAdultMessage: 'Driver age is not a legal adult',
        contactSave: 'Save Info',
        viewLicense: 'View License',
        licenseSave: 'Save License',
        uploadLicenseLabel: 'Upload your drivers license (front and back) (Max 2)',
        updateContactOkMessage: 'Contact data updated',
        uploadLicenseRequiredLengthFilesMessage: "Select front and back images for your driver's license",
        uploadLicenseFileOkMessage: "Driver's license updated",
      },
      location: {
        title: 'Address',
        addressLabel: 'Full address',
        streetLabel: 'Street',
        streetPlaceHolder: 'Street name',
        externalNumber: 'External Number',
        externalNumberPlaceHolder: 'Address external number',
        district: 'Neighborhood',
        districtPlaceHolder: 'Neighborhood',
        zipCode: 'Postal Code',
        zipCodePlaceHolder: 'Postal code',
        phone: 'Phone',
        phonePlaceHolder: 'Add your phone number',
        email: 'Email',
        emailPlaceHolder: 'Add your email',
        province: 'Province',
        locality: 'Locality',
        localityPlaceHolder: 'Locality',
        addressSave: 'Save Address',
        updatedContactAdressMessage: 'Contact address data updated',
        currenteOwnerLocationLabel: 'Owner is approximately located on',
      },
    },
  },
  home: {
    title: 'Home',
    panelLeft: {
      userLabel: 'User',
      userNewAccountLabel: 'New Account',
      userResetPasswordLabel: 'Reset Password',
      userEditAccountLabel: 'Edit Account',
      item: 'Loans (test)',
    },
    panelRight: {
      userLabel: 'User',
      userRegister: 'Register',
      sessionLabel: 'Session',
      sessionLogInLabel: 'Login',
      sessionLogOutLabel: 'Logut',
      lightThemeLabel: 'Light Theme',
      selectLanguageLabel: 'Language',
      sessionLogOutMessage: 'You have logged out.',
      allowWebNotifications: 'Notifications (web)',
      notAllowedWebNotificationsMessage: 'If you don not allow notifications, you will be not be able to receive messages when you a get request for your car or when someone ask for yours',
    },
    topMenu: {
      offer: 'Offer',
      lend: 'Lend',
      howItWorks: 'How it works?',
      contact: 'Contact',
      notifications: 'Notifications',
    },
    main: {
      borrowCarLabel: 'Borrow a car',
      sloganLabel: 'Together we make the world more sustainable.',
      whatCarsLabel: 'What cars are available?',
      location: 'Location',
      date: 'Date',
      viewAvailabilityLabel: 'View Availability',
      flexible: 'Flexible',
      durable: 'Durable',
      transparent: 'Transparent',
      loanOfferLabel: 'Loan offer',
      enterLocationToSearch: 'Enter a location to search',
      currentSelectedPlaces: 'Current selected places',
    },
  },
  car: {
    dashboard: {
      title: 'Dashboard',
      carList: 'Car list',
      additionalData: 'Additional data',
      aboutLender: 'About lender',
    },
    features: {
      titleShort: 'Features',
      titleDialog: 'Select Car Features',
      isUsed: 'Used?',
      name: 'Name',
      value: 'Value',
    },
    restrictions: {
      titleShort: 'Restrictions',
      titleDialog: 'Select Car Restrictions',
    },
    penalties: {
      titleShort: 'Penalties',
      titleDialog: 'Penalties On Misusing',
    },
    edit: {
      title: 'Car Data Edition',
      useMyCarLabel: 'I want to lend my car',
      manufacturerLabel: 'Car Brand',
      modelLabel: 'Model',
      yearLabel: 'Year of Manufacture',
      priceLabel: 'Price',
      descriptionLabel: 'Description',
      carSave: 'Save Car Info',
      carImageUploadLabel: 'Car image',
      carImageUploadSave: 'Upload Car Image',
      carPlateUploadLabel: 'Plate image',
      carPlateUploadSave: 'Upload Car Plate',
      carFeatureLabel: 'Car Features',
      carUseRestrictionLabel: 'Car Use Restrictions',
      carImagesPhotoBrowserLabel: 'Car Images',
      carImageFileListLabel: 'Upload Images List',
      uploadCarImagesLabel: 'Upload your cars images (Max 6)',
      updatedCarMessage: 'Car data successfully updated',
      selectFileToUpload: 'Select a file to upload',
      carImageUploadedOkMessage: 'Car image successfully uploaded',
      carPlateUploadedOkMessage:'Car plate successfully uploaded',
      uploadCarImagesLimitMessage: 'You must select 6 images for your car',
      carImageListUploadedOkMessage: 'Car image list successfully uploaded',
      carIsUsedStatusMessage: 'Car is on a borrow request right now, can not be updated right now',
      carSize: 'Car Size',
      carEstimatedPrice: 'Car Estimated Price',
      suggestedLoanPrice: 'Suggested Loan Price',
      carMinPrice: 'Car Min Price',
      carMaxPrice: 'Car Max Price',
      minRecommendedPrice: 'Min Recommended Price',
      maxRecommendedPrice: 'Max Recommended Price',
      checkSizeMessage: 'Select a car size to determine suggested price',
      //recommendedPriceMessage: 'Price must be between %% and %%, actual price: %%',
      recommendedPriceMessage: 'Set the daily price for your [%%] car between [€%%] and [€%%] to keep it attractive for renters',
      licensePlate: "License Plate",
      selectRestrictedDateLabel: 'Select Restricted Dates',
      selectRestrictedDatePlaceholder: 'Select Restricted Dates',
      saveRestrictedDates: 'Save Dates',
      selectRestrictedDates: 'Select Dates',
      deleteAllRestrictedDates: 'Delete All Dates',
      errorRestrictedDate: 'Select some dates to restrict your car to be loaned',
      messageRestrictedDate: 'Restricted dates saved for this car',
      confirmDeleteRestrictedDate:'Would you like to delete all current restricted dates for your car?',
      messageDeletedRestrictedDate:'All restricted dates for this car has been deleted',
      carPreferredDeliveryTime: 'Preferred Delivery Time',
      carPreferredReturnTime: 'Preferred Return Time',
      penaltiesForMisusing: 'Penalties For Misusing',
    },
  },
  loan: {
    title: 'Loan',
    lends: 'Lends',
    borrows: 'Borrows',
    tabs: [
      'Request',
      'Deciding',
      'Payment',
      //'Insurance',
      'Appointment',
      'Meeting',
      'Stopping',
      'Returning',
      'Rating',
      'Issues',
    ],
    dashboard: {
      carLoanTag: 'Label',
      lender: 'Lender',
      borrower: 'Borrower',
      startDate: 'Start Date',
      endDate: 'End Date',
      daysToBorrow: 'Days to Borrow',
      totalToPay: 'Total to Pay',
      discounts: 'Discounts',
      isGoingAbroad: 'Is Going Abroad',
      returningKilometers: "Returning km's",
      currentKilometers: "Current km's",
      pricePerDay: 'Price per Day',
    },
    request: {
      loanPeriod: 'Loan Period',
      loanRangeDatePlaceHolder: 'Select date range',
      onlyDriver: 'Only one driver',
      driveAbroad: 'Are you going to drive abroad? (+€1 per day)',
      extraDriverData: 'Extra driver data',
      messageRangeDate: 'Select a range of dates you will be traveling',
      onEmptyFormField: 'Please fill extra driver data, field: %%',
      confirmSaveRequest: 'Please, add your password to confirm that you agree to request for this car',
      messageSavedRequest: 'Lender will need to accept your request',
      onLoanPeriodAtLeast3Days: 'The loan period must be set at least 3 days from today',
      onLoadPeriodGreater30Days: 'Loan period can not be greater than 30 days',
      loanPeriodStartTime: 'Select loan start time',
      loanPeriodEndTime: 'Select loan end time',
      buyoutDeposit: 'Buyout deposit',
      buyoutDepositOption: 'Select a buyout deposit option',
      messageOngoingDates:'This car has some reserved dates to be used, choose some unused dates',
      messageRestrictedDates:'This car has some restricted dates to be used, choose some unused dates',
      aboutCarOwner: 'About its owner',
      userRatingLabel: 'User rating',
      invoice: {
        title: 'Total Payment',
        details: 'Invoice details',
        basePrice: 'Price €%% in %% days',
        depositFee: 'Buyout Deposit Fee',
        depositToPay: 'Deposit to Pay',
        daysToBorrow: 'Days to Borrow',
        weeksToBorrow: 'Weeks to Borrow',
        discountPercent: 'Discount %%%',
        totalDiscount: 'Total Discount',
        daysToGoAbroad: 'Days To Go Abroad',
        weekendSurcharge: 'Weekend Surcharge %%%',
        holidaySurcharge: 'Holiday Surcharge',
        serviceFee: 'Service Fee',
        administrativeFee: 'Administrative Fee',
        underAgeRate: 'Under Age Rate',
        subtotal: 'Subtotal',
        taxes: 'Taxes',
        totalToPay: 'Total to Pay',
      },
    },
    deciding: {
      confirmCancel: 'Would you like to CANCEL to lend this car?',
      messageCancel: 'Loaner has declined to loan car. Canceling operations ...',
      confirmAccept: 'Would you like to accept to lend your car?',
      messageAccept: 'You are required deposit of an insurance policy',
      hasDecided: 'has decided to ask for your car',
      loanInfo: 'Loan info',
      yourEarnings: 'Your earnings',
    },
    payment: {
      title: 'Your loan is almost ready, please proceed to pay to continue',
      goPay: 'Proceed to pay',
      popupTitle: 'Your payment',
      messageStripePaymentStatus: 'Your payment was %%',
      confirmCancel: 'Would you like to CANCEL payment for request car?',
      messageCancel: 'Lender has declined to pay for car. Canceling operations ...',
      messageAfterSucceded: 'Lender has been notified now to prepare insurance and you must expect an appointment to continue',
    },
    appointment: {
      labelData: 'Appoinment data',
      pleaseNote: 'Please note that',
      notRenting: 'De LeenAuto is not a rental service, instead is a borrow and loan service, so it is safe to make an external insurance with safety',
      noLawIssues: 'Also, the Borrower has been duly examined to ensure that he has not had contact with the justice system and/or has declared it, and that the Borrower has also declared compliance with the General Terms and Conditions of DeLeenAuto',
      agreedOnRequirements: 'Finally, the statement, requirements and all conditions of the external insurance coincide with the General Terms and Conditions of DeLeenAuto',
      insuranceFrom: ' De LeenAuto recommends do this through',
      insuranceHasBeenAdded: 'I have added insurance to my car',
      selectAppointmentDate: 'Select a date for meeting with your borrower',
      selectAppointmentPlace: 'Select a place for meeting with your borrower',
      confirmAddedInsurance: 'Confirm that you have added an insurance',
      noAppointmentSelected :'No appointment date was selected',
      noPlaceEntered: 'No place was entered',
      confirmMeeting:'Would you like to meet your borrower in %% at %%?',
      messageMeeting: 'Borrower will be notified to meet you in %% at %%',
    },
    meeting: {
      uploadCarLoanImagesLabel: "Upload car's current images (Max 8)",
      uploadDriverImagesLabel: "Upload driver's licenses (owner, borrower + extra) (Max 7)",
      currentFuelLevel: 'Current fuel level',
      currentKilometers: 'Current Kilometers',
      imageListLimitMessage: 'You must select %% images to upload',
      confirmStartLoan: 'Would you like to start the loan?',
      confirmEndLoan: 'Would you like to end the loan?',
      showCarImageLabel: "Show car's images",
      showDriverImageLabel: "Show drivers' images",
      emptyTank: 'Fuel tank can not be empty',
      kilometersBelowOne: 'Kilometers can not be less than zero',
    },
    backAppointment: {
      selectAppointmentDate: 'Select a date for meeting with your lender',
      selectAppointmentPlace: 'Select a place for meeting with your lender',
      confirmMeeting:'Would you like to meet your lender in %% at %%?',
      messageMeeting: 'Lender will be notified to meet you in %% at %%',
    },
    issue: {
      checkLabel: 'Did you have any issue?',
      description: 'Describe your issue',
      placeholder: 'Any issue?',
      descriptionTooLong: 'Your issue is too long',
      askCreateIssue: 'Would you like to create an issue?',
      newIssueCreated: 'Issue created',
      askCloseLoan: 'Do you want to close your loan as "Finished successfully"?',
      closedLoanSuccess: 'Loan closed successfully',
      tagMarkedIssues: 'Mark all issues you had',
      buttonProceed: 'Proceed to Evaluate Issue',
      noIssueSelected: 'No issue was selected',
      askProceedIssue: 'Would you like to proceed with your issue?',
    },
    rating: {
      yourRatingLabel: 'Your rating',
      yourFeedbackLabel: 'Your feedback',
      sendFeedback: 'Send Feedback',
      textPlaceHolder: 'Your feedback here',
      chooseStarMessage:'Select a star for rating',
      editorMessage: 'Please, add some feedback',
      afterSaveMessage: 'Your feedback has been added',
      starLabel: '%% rating',   /* User:lender or borrower rating */
      userLabel: '%% feedback', /* User:lender or borrower feedback */
    },
    statusLabel: {
      1: 'Requested',
      2: 'Acepted',
      3: 'Paid',
      4: 'Agreed meet',
      5: 'Loaned',
      6: 'Agreed return',
      7: 'Returned',
      8: 'Finished',
      9: '--Reserved--',
      10: 'Finished with issues',
      11: '--Reserved--',
      12: 'Canceled by Lender',
      13: 'Canceled by Borrower',
    },
    signImage: {
      title: 'Add your sign to confirm car loan acceptance',
      noSignMessage: 'No sign was written, please add one',
    },
  },
  admin: {
    title: 'Admin Panel',
    sections: {
      carPricing: 'Smart Pricing',
      carPricingEdit: 'Pricing Edition',
      carLoanGrid: 'Current Open Loans',
      buyoutDeposit: {
        adminButton: 'Buyout Deposits',
        panelTitle: 'Buyout Deposits Options',
        editTitle: 'Buyout Deposit Edition',
        feeLabel: 'Buyout Deposit Fee',
        toPayLabel: 'Buyout Deposit To Pay',
        displayMessageLabel: 'Message To Display On Select',
        showOptionLabel: 'Show option on select list',
        messageNoEdited: 'This option can not be edited',
      },
      refund: {
        adminButton: 'Refunds',
        panelTitle: 'Cars Loaned With Issues',
        loanTag: 'Loan Tag',
        edit:{
          tagLoan: 'Loan Data / Start Date / End Date',
          tagUsers: 'Lender / Borrower',
          tagFuel: 'Fuel on init / Fuel on return',
          tagPlace: 'Place of delivery / Place of return',
          tagDate: 'Date of delivery / Date of return',
          tagOdometer: 'Odometer on init / Odometer on return',
          tagIssueComment: 'Issue comments',
          tagIssueImages: 'Issue Images',
          tagMarkedIssues: 'All issues user had',
          tagCancelIssue: 'Would you like to cancel this refund?',
          tagCancelMessage: 'This issue has been canceled',
          tagAcceptIssue: 'Would you like to proceed with the refund?',
          tagAcceptMessage: 'This issue has been approved to be refunded, proceed however you like, I get no idea',
        },
      },
    },
  },
  googleMap: {
    dialog: {
      title: 'Search',
      inputTitle: 'Search for a location',
      inputPlaceHolder: 'Enter a location ...',
    },
  },
  document: {
    borrowerDetails: 'Part I: Borrower/Driver Details',
    extraDriverDetails: 'Optional: Extra Driver Details',
    lenderDetails: 'Part II: Lender Details',
    rentailPeriodDetails: 'Rental Period Details',
    carDetails: 'Car Details',
    allowedProhibitedActions: 'Allowed & Prohibited Actions',
    contractSigning: 'Contract Signing',
    partBorrower: 'Part I: Borrower',
    partLender: 'Part II: Lender',
    pickUpTime: 'Pick-Up Time',
    returnTime: 'Return Time',
    locationPickReturn: 'Pick-Up & Return Location',
  },
};

export default dictionaryEN;
